import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import CheckedValue from 'src/views/admin/CheckedValue';
import FormikCheckboxes from 'src/components/formik-checkboxes';
import {EducationPhase} from 'src/types/enums';

const EDUCATION_PHASE_OPTIONS = [EducationPhase.HIGH_SCHOOL, EducationPhase.COMMUNITY_COLLEGE].map(
  (educationPhase) => ({
    _id: educationPhase,
    value: educationPhase,
    label: educationPhase,
  })
);

const EducationPhaseSelection = () => (
  <FormikCheckboxes name="educationPhases" options={EDUCATION_PHASE_OPTIONS} required={false} />
);

const columns: ColumnSettings[] = [
  {
    name: 'name',
    title: 'Name',
    sortable: true,
  },
  {
    name: 'isNormal',
    title: 'Normal?',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'isAp',
    title: 'AP?',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'isIb',
    title: 'IB?',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'isCertification',
    title: 'Certification?',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'isCollegeLevel',
    title: 'CollegeLevel?',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'educationPhases',
    title: 'Education Phases',
    renderValue: function educationPhasesDisplay(value: string | number | string[]): string {
      if (Array.isArray(value)) value = value.join(', ');
      return value + '';
    },
    FormField: EducationPhaseSelection,
  },
];

const CourseListings = () => (
  <div>
    <h1 className="shared-font headline">Course Listings</h1>
    <EditableTable
      basePath="/v1/admin/course-listings"
      defaultSortKey="name"
      columns={columns}
      identifier="course-listings"
      defaultValues={{
        educationPhases: [],
        isNormal: false,
        isAp: false,
        isIb: false,
        isCertification: false,
        isCollegeLevel: false,
      }}
    />
  </div>
);

export default CourseListings;
